import React, { useContext } from 'react';
import { LuBuilding2 } from 'react-icons/lu';
import { baseRoot } from '../../../api/Apis';
import Logo from '../../../assets/image/FHO - Logo-14001223-Test-2-2-Final-1.png';
import faresWhite from '../../../assets/image/l.png';
import { TextContext } from '../../../context/TextCotext';

export const LoginPlantInfo = ({ InfoData }) => {
  const { version } = useContext(TextContext);

  const renderDescriptionContent = ({ title, Owner }) => {
    return (
      <>
        <span
          className="backdrop-contrast-50 p-3 rounded-full font-medium text-white"
          style={{ fontFamily: 'inherit' }}
        >
          <LuBuilding2 className="inline" /> : {title ?? '--'}
        </span>
        <span
          className="backdrop-contrast-50 p-3 rounded-full font-medium text-white"
          style={{ fontFamily: 'inherit' }}
        >
          Owner : {Owner ?? '--'}
        </span>
      </>
    );
  };

  return (
    <>
      <img className="absolute w-20 h-5 top-10 right-6" src={faresWhite} />
      <div className="flex flex-col gap-16 items-center justify-center h-screen ">
        <div className="w-72 h-72 flex flex-col rounded-full bg-white items-center justify-center">
          <img
            className="w-44 h-44 flex flex-col items-center justify-center "
            src={InfoData?.image ? `${baseRoot}/api/uploads/${InfoData?.image}` : Logo}
          />
        </div>
        <div className="flex flex-col gap-2 items-center justify-center">
          {renderDescriptionContent({
            title: InfoData.plantName,
            Owner: InfoData.ownerName,
          })}

          <div className="absolute bottom-10 text-sm text-stone-200">
            Version : {version}
          </div>
        </div>
      </div>
    </>
  );
};
